export const generateRatings = (request, map) => {
  const item = map.get(request.rating ?? '0');
  map.set(item.id, { ...item, value: item.value + 1 });
};
